<template>
  <div>
    <CurrencyInput v-if="isCurrency" v-model="model" v-bind="{...$attrs, ...props}" />
    <div>
      <FormulateInput ref="slider" :id="name" type="range" v-model="model" :min="min" :max="max" />
      <div v-if="props.optimalTips && visibleTips" class="formulate-input-tip-wrapper">
        <p class="formulate-input-tip" :style="tipStyle">{{ isEnough ? 'óptimo' : 'no es suficiente' }}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CurrencyInput from '@/lego/components/inputs/numeric/CurrencyInput.vue';
import { computed, onMounted, ref, watchEffect } from '@vue/composition-api';
import { defineCssVars } from '@/lego/utils/style/vars';

export default {
  components: { CurrencyInput },
  props: {
    type: {
      type: String,
      default: 'currency',
    },
    value: {
      type: String,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 20000000,
    },
    optimalTips: {
      type: Boolean,
      default: false,
    },
    optimalVal: {
      type: Number,
      required: false,
    },
  },
  setup(props, { root }) {
    const slider = ref(null);
    const model = ref(0);
    const visibleTips = computed(() => props.optimalTips && !!model.value && parseInt(model.value) > 0);
    const name = computed(() => 'slider-' + root.$attrs.name);
    const isCurrency = computed(() => props.type === 'currency');
    const isEnough = computed(() => model.value >= props.optimalVal);

    const getSliderColor = function() {
      return isEnough.value ? '#0CC175' : '#D80003';
    };
    const sliderColor = computed(() => (props.optimalTips ? getSliderColor() : '#6B7280'));
    const sliderPercent = computed(() => ((model.value - props.min) / (props.max - props.min)) * 100);
    const sliderStyle = computed(() => `linear-gradient(to right, ${sliderColor.value} 0%, ${sliderColor.value} ${sliderPercent.value}%, #D1D5DB ${sliderPercent.value}%, #D1D5DB 100%)`);
    const tipStyle = computed(() => ({
      color: sliderColor.value,
      left: `${sliderPercent.value}%`,
    }));

    onMounted(() => {
      watchEffect(() =>
        defineCssVars(
          {
            '--slider-background': sliderStyle.value,
          },
          slider.value.$el
        )
      );
      model.value = props.value ?? 0;
    });

    return {
      slider,
      visibleTips,
      model,
      props,
      isCurrency,
      isEnough,
      name,
      sliderStyle,
      tipStyle,
    };
  },
};
</script>

<style lang="postcss" scoped>
/deep/ .formulate-input {
  &[data-type='range'] {
    @apply mt-xxxs;
  }
  &-element {
    &--range {
      @apply border-none;

      input {
        @apply w-full !p-0 appearance-none h-nano rounded-pill;

        background: var(--slider-background);

        &::-webkit-slider-thumb {
          @apply appearance-none rounded-circular bg-brand-secondary-dark w-[1.25rem] h-[1.25rem];
        }
      }
    }
    &-range-value {
      @apply bg-brand-secondary-dark;
    }
  }
  &-tip {
    @apply w-fit absolute style-overline -translate-x-1/3;

    &-wrapper {
      @apply w-full relative py-nano;
    }
  }
}
</style>
